import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36012a0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"4px"} }, null, -1))
const _hoisted_2 = { class: "flex items-center gap-1.5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "self-start" }, "|", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "self-start" }, "|", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "self-start" }, "|", -1))
const _hoisted_6 = { class: "m-1 mt-0.5 flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "absolute"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onDragstart", "onTouchstart"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onDragstart", "onTouchstart", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"1px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Undo = _resolveComponent("Undo")!
  const _component_ToggleGrid = _resolveComponent("ToggleGrid")!
  const _component_TogglePoint = _resolveComponent("TogglePoint")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_DeletePoint = _resolveComponent("DeletePoint")!
  const _component_SplitSegment = _resolveComponent("SplitSegment")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_Close = _resolveComponent("Close")!
  const _component_Layers = _resolveComponent("Layers")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-slate-400",
    onDrop: _cache[8] || (_cache[8] = ($event: any) => (_ctx.drop($event))),
    onDragenter: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
    onDragover: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      style: _normalizeStyle(`width:${_ctx.canvasParams.canw + _ctx.canvasParams.sidew + 4}px;
      height:${_ctx.canvasParams.headh}px`),
      class: "ml-1 flex items-center justify-between bg-slate-300 px-4"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Undo, {
          isUndoable: _ctx.isUndoable,
          isRedoable: _ctx.isRedoable,
          onUndo: _ctx.undo,
          onRedo: _ctx.redo
        }, null, 8, ["isUndoable", "isRedoable", "onUndo", "onRedo"]),
        _hoisted_3,
        _createVNode(_component_ToggleGrid, {
          onToggleGrid: _ctx.toggleGrid,
          grid: _ctx.grid
        }, null, 8, ["onToggleGrid", "grid"]),
        _hoisted_4,
        _createVNode(_component_TogglePoint, {
          onTogglePoint: _ctx.togglePoint,
          isSharpCorner: _ctx.isSharpCorner
        }, null, 8, ["onTogglePoint", "isSharpCorner"]),
        _createVNode(_component_Slider, {
          value: _ctx.stagingRatio,
          onUpdateValue: _ctx.updateRatio
        }, null, 8, ["value", "onUpdateValue"]),
        _createVNode(_component_DeletePoint, {
          onDeletePoint: _ctx.deletePoint,
          cursors: _ctx.cursors
        }, null, 8, ["onDeletePoint", "cursors"]),
        _createVNode(_component_SplitSegment, { onSplitSegment: _ctx.splitSegment }, null, 8, ["onSplitSegment"]),
        _hoisted_5,
        _createVNode(_component_color_picker, {
          pureColor: _ctx.stagingColor,
          "onUpdate:pureColor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stagingColor) = $event))
        }, null, 8, ["pureColor"])
      ]),
      _createVNode(_component_Close, { onOnClose: _ctx.onClose }, null, 8, ["onOnClose"])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        style: _normalizeStyle(`width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;`),
        onDragover: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args))),
        onTouchmove: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args))),
        ref: "divCanvas"
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(`width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;`),
          class: "absolute overflow-hidden bg-slate-100"
        }, [
          _createElementVNode("img", {
            src: _ctx.gridImage,
            class: "absolute",
            style: _normalizeStyle(`width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;`)
          }, null, 12, _hoisted_7),
          (_ctx.currentDrawing.remix.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.currentDrawing.remix.image,
                class: "absolute",
                style: _normalizeStyle(
              `width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;` +
              `Transform: ${_ctx.remixTransformString};`
            )
              }, null, 12, _hoisted_8))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDrawing.layers, (layer, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              src: layer.svgImage,
              class: "absolute",
              draggable: "false",
              style: _normalizeStyle(
              `width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;` +
              `opacity:1.0`
            ),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickToPickLayer($event)))
            }, null, 12, _hoisted_9))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDrawing.overlays, (overlay, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              src: overlay.image,
              class: "absolute",
              draggable: "false",
              style: _normalizeStyle(
              `width:${_ctx.canvasParams.canw}px; height:${_ctx.canvasParams.canh}px;` +
              `opacity:1.0; Transform: ${_ctx.overlayTransform(index)}`
            ),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickToPickLayer($event)))
            }, null, 12, _hoisted_10))
          }), 128))
        ], 4),
        (_ctx.hasLayerMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "tool-handle-move absolute",
                style: _normalizeStyle(
              `width:${_ctx.canvasParams.curw}px; height:${_ctx.canvasParams.curh}px; ` +
              `left: ${_ctx.moveToolPos.left}px; ` +
              `top: ${_ctx.moveToolPos.top}px; `
            ),
                draggable: "true",
                onDragstart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragLayerImgStart($event))),
                onTouchstart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragLayerImgStart($event))),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClickToolHandle()))
              }, null, 36),
              (_ctx.toolHandleMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolHandles, ({ type, x, y }, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["absolute", 
                type === _ctx.Tools.ROTATE
                  ? 'tool-handle-rotation'
                  : 'tool-handle-scaling'
              ]),
                        style: _normalizeStyle(`width:${_ctx.canvasParams.curw}px; height:${_ctx.canvasParams.curh}px;
              left: ${x}px; top: ${y}px;`),
                        draggable: "true",
                        onDragstart: ($event: any) => (_ctx.dragToolHandleStart($event, type)),
                        onTouchstart: ($event: any) => (_ctx.dragToolHandleStart($event, type))
                      }, null, 46, _hoisted_13))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cursors, (cursor, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: _normalizeStyle(`width:${_ctx.canvasParams.curw}px; height:${
                _ctx.canvasParams.curh
              }px; left:${
                _ctx.assetXtoCanvasX(cursor.x) - _ctx.canvasParams.curw / 2
              }px; top:${_ctx.assetYtoCanvasY(cursor.y) - _ctx.canvasParams.curh / 2}px`),
                        class: _normalizeClass([`${
                index == _ctx.pointIndex ? 'border-blue-800' : 'border-blue-400'
              } ${cursor.c ? '' : 'rounded-xl'}`, "absolute border-2 border-solid"]),
                        draggable: "true",
                        onDragstart: ($event: any) => (_ctx.dragStart($event, index)),
                        onTouchstart: ($event: any) => (_ctx.dragStart($event, index)),
                        onClick: ($event: any) => (_ctx.onSelect($event, index))
                      }, null, 46, _hoisted_15))
                    }), 128))
                  ]))
            ]))
          : _createCommentVNode("", true)
      ], 36),
      _createElementVNode("div", {
        style: _normalizeStyle(`width:${_ctx.canvasParams.sidew + 2}px; height:${
          _ctx.canvasParams.canh
        }px;`),
        class: "ml-1 bg-slate-300"
      }, [
        _createVNode(_component_Layers, {
          drawing: _ctx.currentDrawing,
          layerIndex: _ctx.layerIndex,
          overlayIndex: _ctx.overlayIndex,
          newLayer: _ctx.newLayer,
          remixes: _ctx.remixes,
          currentLayerType: _ctx.currentLayerType,
          addresses: _ctx.addresses,
          canvasOffset: _ctx.canvasOffset,
          onUpdateRemix: _ctx.updateRemix,
          onOnSelectLayer: _ctx.onSelectLayer,
          onUpdateLayers: _ctx.updateLayers,
          onRemixSelected: _ctx.remixSelected,
          onOnSelectOverlay: _ctx.onSelectOverlay,
          onUpdateOverlays: _ctx.updateOverlays
        }, null, 8, ["drawing", "layerIndex", "overlayIndex", "newLayer", "remixes", "currentLayerType", "addresses", "canvasOffset", "onUpdateRemix", "onOnSelectLayer", "onUpdateLayers", "onRemixSelected", "onOnSelectOverlay", "onUpdateOverlays"])
      ], 4)
    ]),
    _hoisted_16
  ], 32))
}